/*
 * InSight Analytics Solutions Limited
 * https://fieldpro.onyxinsight.com/
 *
 * Copyright (c) 2021 Onyx InSight Field Pro.
 * This file is licensed to InSight Analytics Solutions Limited
 */
/* NPM Imports Start */
import React, {
  useState,
  useEffect,
  createContext,
  useContext,
  useCallback,
} from 'react';
import _ from 'lodash';
import Cookies from 'universal-cookie';
import { useDispatch } from 'react-redux';
import { resetState } from '../store/action/userAction';
import { maxAge } from '../constant';
import serviceCall from '../store/serviceCall/index';
import { ToasterMessage } from '../components/sharedComponents';
import { LOCAL_STORAGE_PLANNING_ITEMS_KEY } from '../constants/localStorageKeys';

/* NPM Imports End */

/* Project Imports Start */

/* Project Imports End */

/* CCS & Image imports Start */

/* CCS & Image imports End */

const AuthContext = createContext({});
const useAuth = () => useContext(AuthContext);
const defaultUser = {
  email: 'sandra@example.com',
  avatarUrl:
    'https://js.devexpress.com/Demos/WidgetsGallery/JSDemos/images/employees/06.png',
};
const cookies = new Cookies();
function AuthProvider(props) {
  const dispatch = useDispatch();
  const userdetailData = JSON.stringify(cookies.get('userdetails'));
  const objectdetail = userdetailData
    ? {
        userdetail: JSON.parse(userdetailData),
        avatarUrl: defaultUser.avatarUrl,
      }
    : null;
  const [user, setUser] = useState(objectdetail);
  const [loading, setLoading] = useState(true);

  const logIn = useCallback(async (userdetail, customer) => {
    const currentCustomer = _.filter(userdetail.customers, function(o) {
      return o.companyName === customer;
    });
    userdetail.customers = currentCustomer;
    // Send login request
    if (cookies.get('token')) {
      cookies.set('userdetails', `${JSON.stringify(userdetail)}`, {
        path: '/',
        maxAge,
      });
      setUser({
        userdetail,
        avatarUrl: defaultUser.avatarUrl,
      });
    }
  }, []);

  const logOut = useCallback(() => {
    // Clear user data
    serviceCall
      .getData('Users/LogOutWeb')
      .then(() => {
        dispatch(resetState());
        cookies.remove('token', { path: '/' });
        cookies.remove('linkNavigationUrl');
        cookies.remove('userdetails', { path: '/' });
        window.location.reload();
        localStorage.removeItem(LOCAL_STORAGE_PLANNING_ITEMS_KEY);
      })
      .catch(() => {
        ToasterMessage('error', 'something went wroung');
      });
  }, []);

  const setCustomer = useCallback(async customer => {
    serviceCall.postDataNew('Users/SetSessionCustomer');
  });

  useEffect(() => {
    // Retrieve and save user data on initial load

    setLoading(false);
  }, []);

  return (
    <AuthContext.Provider
      value={{ user, logIn, logOut, setCustomer, loading }}
      {...props}
    />
  );
}

export { AuthProvider, useAuth };
